const replaceAccents = function (str) {
  const accents =
    'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  const accentsOut =
    'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
  const cleanStr = [];

  for (const i in str) {
    const index = accents.indexOf(str[i]);

    cleanStr[i] = index !== -1 ? accentsOut.substr(index, 1) : str[i];
  }

  return cleanStr.join('');
};

// The slugs come from `parameterize`, so a query keeping its spaces matches nothing:
// one trailing space used to empty the whole list.
const slugify = value =>
  replaceAccents(value.toLowerCase())
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

export const filter =
  (groups, groupElSelector, modifierClass = 'c-filtered-out') =>
  e => {
    e.stopPropagation();

    const search = slugify(e.target.value);

    // for each group
    groups.forEach(group => {
      const filtredEl = group.querySelectorAll(groupElSelector);

      // for each item in that group
      filtredEl.forEach(el => {
        const elSlug = el.dataset.filterSlug;

        el.classList[elSlug.indexOf(search) !== -1 ? 'remove' : 'add'](
          modifierClass,
        );
      });

      group.classList[
        group.querySelectorAll(`${groupElSelector}:not(.${modifierClass})`)
          .length
          ? 'remove'
          : 'add'
      ](modifierClass);
    });
  };
